import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/valueTypeConditions', request)
}

export {get}
